import imgOutside from '../../assets/buildings/school/outside.png';
import imgWasteWater from '../../assets/buildings/school/waste-water.png';
import imgFireProtection from '../../assets/buildings/school/fire-protection.png';
import imgHeating from '../../assets/buildings/school/heating.png';
import imgWater from '../../assets/buildings/school/water.png';
import { Building } from '../../interfaces/buildings';
import { ProductType } from '../products';
import { TechSector } from '../tech-sector';

const schoolConfig: Building = {
    techSectors: [
        {
            type: TechSector.WASTE_WATER,
            img: imgWasteWater,
            products: [
                {
                        position: { x: 592, y: 902 },
                    type: ProductType.COMPACTA,
                },
                {
                        position: { x: 1095, y: 870 },
                    type: ProductType.AMAPORTER,
                },
                {
                        position: { x: 1097, y: 690 },
                    type: ProductType.LEVELCONTROL_BASIC_2,
                },
                {
                        position: { x: 1495, y: 798 },
                    type: ProductType.AMA_DRAINER_BOX_UNTERFLUR,
                },
                {
                        position: { x: 1731, y: 864 },
                    type: ProductType.AMA_DRAINER_4_5,
                },
            ],
        },
        {
            type: TechSector.FIRE_PROTECTION,
            img: imgFireProtection,
            products: [
                {
                        position: { x: 846, y: 921 },
                    type: ProductType.HYADUO_2_D_FL_COMPACT,
                },
            ],
        },
        {
            type: TechSector.HEATING,
            img: imgHeating,
            products: [
                {
                        position: { x: 208, y: 894 },
                    type: ProductType.BOAX_S_SF,
                },
                {
                        position: { x: 271, y: 857 },
                    type: ProductType.SERIE_2000,
                },
                {
                        position: { x: 359, y: 886 },
                    type: ProductType.ETANORM,
                },
                {
                        position: { x: 421, y: 862 },
                    type: ProductType.BOA_CONTROL_IMS,
                },
                {
                        position: { x: 549, y: 831 },
                    type: ProductType.SISTO_16_RGAMAXX,
                },
                {
                        position: { x: 766, y: 826 },
                    type: ProductType.BOA_CONTROL_DPR,
                },
                {
                        position: { x: 827, y: 839 },
                    type: ProductType.CALIO_PRO_PLUS_Z,
                },
                {
                        position: { x: 916, y: 803 },
                    type: ProductType.BOA_CONTROL_SBV,
                },
                {
                        position: { x: 1012, y: 833 },
                    type: ProductType.CALIO_PRO_PLUS,
                },
                {
                        position: { x: 1093, y: 818 },
                    type: ProductType.BOA_RVK,
                },
                {
                        position: { x: 1190, y: 872 },
                    type: ProductType.ETALINE_Z,
                },
                {
                        position: { x: 1500, y: 812 },
                    type: ProductType.BOATRONIC_MP,
                },
            ],
        },
        {
            type: TechSector.WATER,
            img: imgWater,
            products: [
                {
                        position: { x: 384, y: 875 },
                    type: ProductType.AMA_DRAINER_BOX_UEBERFLUR,
                },
                {
                        position: { x: 414, y: 806 },
                    type: ProductType.SISTO_16_TWA,
                },
                {
                        position: { x: 524, y: 832 },
                    type: ProductType.KSB_SAFETY_BOOST,
                },
                {
                        position: { x: 621, y: 833 },
                    type: ProductType.SISTO_16_RGAMAXX,
                },
            ],
        },
],
    img: imgOutside,
};

export default schoolConfig;
